import PropTypes from 'prop-types';
export const productsPropTypes = {
  /**
   * Heading content
   */
  heading: PropTypes.string,
  /**
   * Array of objects containing product data
   */
  items: PropTypes.arrayOf(PropTypes.shape({
    heading: PropTypes.string,
    href: PropTypes.string,
    picture: PropTypes.shape({
      xs: PropTypes.string,
      alt: PropTypes.string
    })
  }))
};